export default __webpack_public_path__ + "static/SRF Carasweet 5S7303BIO - Product Specifications & Technical Data-a87fdfc3e0acd6b65a0ab20ffcf7ea49.pdf";